module.exports = __webpack_public_path__ + "img/Chef.71c688f1.jpg";